import styled from 'styled-components';

export const Step = styled.section`
  & + & {
    margin-top: 1.25rem;
  }
`;

export const StepTitle = styled.h6`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0.75rem;
  font-size: 14px;
  font-weight: 600;
  color: #3f4254;
`;

export const StepNumber = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #009ef7;
  color: #fff;
  font-size: 12px;
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #eff2f5;
  border-radius: 6px;

  & + & {
    margin-top: 8px;
  }

  strong {
    font-size: 13px;
    color: #3f4254;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const CategoryList = styled.div`
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid #eff2f5;
  border-radius: 6px;
`;

export const Summary = styled.div<{ $ready: boolean }>`
  font-size: 13px;
  color: ${({ $ready }) => ($ready ? '#3f4254' : '#7e8299')};
  max-width: 560px;

  b {
    color: #009ef7;
  }
`;
